/**
 * 编辑器侧「连接数据」会话态缓存（线 I/J 共用，不进 .f3p、不进草稿）：
 * - 每服务最近一次试拉的设备列表（属性轻量绑定下拉用；下次打开工程清空）
 * - 「在场景里看数」轮询句柄
 */
import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { PollLoop } from '@/runtime/source-gateway/pollLoop'
import type { EnrichedDevice } from '@/connect-data/perDevicePoints'

export interface CachedDevices {
  serviceId: string
  /** 带真实点位目录的设备行（assetCode/name/deviceTypeValue/points） */
  devices: EnrichedDevice[]
  pulledAtMs: number
}

export const useConnectDataEditorStore = defineStore('connectDataEditor', () => {
  /** serviceId → 最近一次试拉的设备列表（仅本会话，含每台真实点位） */
  const devicesCache = ref<Record<string, CachedDevices>>({})
  /** 「在场景里看数」的轮询句柄（多服务多条，Hub 持有用于停止） */
  const pollHandles = ref<PollLoop[]>([])
  const polling = ref(false)

  function setDevicesCache(serviceId: string, devices: EnrichedDevice[]) {
    devicesCache.value = {
      ...devicesCache.value,
      [serviceId]: { serviceId, devices, pulledAtMs: Date.now() },
    }
  }

  function getDevicesCache(serviceId: string): CachedDevices | undefined {
    return devicesCache.value[serviceId]
  }

  function setPollHandles(handles: PollLoop[]) {
    stopPoll()
    pollHandles.value = handles
    polling.value = handles.length > 0
  }

  function stopPoll() {
    for (const h of pollHandles.value) h.stop()
    pollHandles.value = []
    polling.value = false
  }

  function reset() {
    stopPoll()
    devicesCache.value = {}
  }

  return {
    devicesCache,
    polling,
    setDevicesCache,
    getDevicesCache,
    setPollHandles,
    stopPoll,
    reset,
  }
})
